import SYMBOLS from '@config/currencymap';

const AcCurrencySymbol = currency => {
  return SYMBOLS[currency.toUpperCase()].symbol_native;
};

export default AcCurrencySymbol;
